export enum ProjectType {
  Basic = 0,
  Advanced = 1,
}
